import { orderBy, reduce } from 'lodash';

import { isObject } from './helperFunctions';

import { STRIPE_PLANS } from '../config/plans';
import { STRIPE_MODE } from '../config/constants';

function getPlanId(cycle) {
  const mode = process.env.REACT_APP_ENV === 'production' ? STRIPE_MODE.LIVE : STRIPE_MODE.TEST;
  for (const planId in STRIPE_PLANS) {
    const plan = STRIPE_PLANS[planId];
    if (plan.cycle === cycle &&
      plan.mode === mode &&
      plan.currentlyOffered
    ) {
      return planId;
    }
  }

  return null;
}

export function getCurrentlyOfferedPlans() {
  const mode = process.env.REACT_APP_ENV === 'production' ? STRIPE_MODE.LIVE : STRIPE_MODE.TEST;
  return reduce(STRIPE_PLANS, (acc, plan, id) => {
    if (plan.currentlyOffered && plan.mode === mode) {
      acc.push({
        ...plan,
        id,
      });
    }
    return acc;
  }, []);
}

export function getPlan(cycle, limit) {
  const planId = getPlanId(cycle, limit);
  if (!planId) return null;
  const plan = STRIPE_PLANS[planId];
  if (!plan) return null;
  return {
    ...plan,
    id: planId,
  };
}

export function getPlanById(id) {
  const mode = process.env.REACT_APP_ENV === 'production' ? STRIPE_MODE.LIVE : STRIPE_MODE.TEST;
  const plan = STRIPE_PLANS[id];
  if (!isObject(plan)) {
    return null;
  }
  // Ensure plan is valid
  return plan.mode === mode && plan.currentlyOffered ? plan : null;
}

export function getSavings(plan) {
  return Math.round(((plan.price.oneTime - plan.price.month) / plan.price.oneTime) * 100);
}

export function getUpsellPlan(planId) {
  const plan = getPlanById(planId);
  if (!plan.upsellPlanId) {
    return null;
  }
  const upsellPlan = getPlanById(plan.upsellPlanId);
  return upsellPlan ? { ...upsellPlan, id: plan.upsellPlanId } : null;
}

export function getCommitmentGroup(selectedPlan) {
  if (!selectedPlan) {
    return null;
  }
  const plans = getCurrentlyOfferedPlans();
  const sortedPlansByCommitmentLevel = orderBy(plans, ['isAnnual'], ['desc']);
  const filteredPlansByLimit = sortedPlansByCommitmentLevel.filter(plan => {
    return Number(plan.limit) === Number(selectedPlan.limit);
  });
  /*
  Plan limit is a numerical value and existing user may have an old plan.
  Currently offered plans may have same `plan limit` with old plan. Extra checking is required in that case.
  What makes plan (or price) unique is it's id.
  If selected plan's id does not belong to currently offered plans, no commitment group should return.
  */
  const isPlanFound = filteredPlansByLimit.some(plan => plan.id === selectedPlan.id);
  return isPlanFound ? filteredPlansByLimit.length ? filteredPlansByLimit : null : null;
}

export function getPlansByCommitmentLevel(userPlan) {
  const plans = getCurrentlyOfferedPlans();
  const sortedPlansByPriceAndPeriod = orderBy(plans, ['price.month', 'isAnnual'], ['desc', 'desc']);
  return sortedPlansByPriceAndPeriod.filter(plan => plan.isAnnual === userPlan.isAnnual);
}

export function getDefaultPlan() {
  const plans = getCurrentlyOfferedPlans();
  return plans.find(plan => plan.isBestPlan);
}

export function isPlanAvailable(plan) {
  if (!isObject(plan)) {
    return false;
  }
  const currentPlan = getPlanById(plan.id);
  return !!currentPlan;
}
/*
 * Checks the plan and coerce it to be current plan
 * plan could be one of the followings;
 * -> null (a plan is not selected yet, return default plan )
 * -> old plan (old plan will not be used anymore, return default plan)
 * -> current plan (plan is found, make it compatible with UI plan as API and client plan objects are not exactly equal)
 */
export function getEquivalentPlan(plan) {
  if (isPlanAvailable(plan)) {
    return getPlanById(plan.id);
  }
  const defaultPlan = getDefaultPlan();
  return defaultPlan;
}

export function getPriceSubText(planType) {
  const priceSubList = ['12 monthly payments', 'Paid in 12 installments'];
  const priceSub = planType === 'update' ? priceSubList[1] : priceSubList[0];
  return priceSub;
}

export function isPlanCurrentlyOfferedAndAnnual(plan) {
  if (isPlanAvailable(plan)) {
    const userPlan = getPlanById(plan.id);
    return userPlan.isAnnual;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/stripePlanUtils.js